module.exports = __webpack_public_path__ + "img/16l002-07.409d79a4.jpg";